import { encode } from '@src/shared/utils/qs'
import { getAnalyticsId } from '@src/shared/utils/analytics'
import { RESET_STORED_DATA } from '@store/constants'
import { handleApplicantError } from '@store/applicant/actions'
import request from '@store/request'

export const resetStoredData = () => ({
  type: RESET_STORED_DATA
})

type SignupMetricsParams = {
  id?: string
  event: string
  data?: Record<string, unknown>
}
/**
 * Send metric data to backend
 * @param {string} id - installation id
 * @param {string} event - action being taken [landing_page-control, landing_page-variant, submit_zipcode, near-zone, out-of-zone, in-zone, submit_application]
 * @param {object} data - any extra data needed for the event such as zipcode or distance
 */
export const signupMetrics =
  ({ id, event, data = {} }: SignupMetricsParams) =>
  async dispatch => {
    try {
      const params = {
        identifier_type: 'installation_id',
        identifier: id || getAnalyticsId(),
        event
      }
      Object.entries(data).forEach(([key, val]) => {
        params[`data.${key}`] = val
      })
      await request()('/signupMetrics', 'post', encode(params))
    } catch (err) {
      dispatch(handleApplicantError(err))
    }
  }
